import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingIndicator from "./LoadingIndicator";

interface OnboardedRouteProps {
  children: React.ReactNode;
}

const OnboardedRoute: React.FC<OnboardedRouteProps> = ({ children }) => {
  const { isAuthenticated, isOnboarded, onboardingLoading, loading } =
    useAuth();
  const location = useLocation();

  // Show loading while auth or onboarding state is being determined
  if (loading || onboardingLoading || isOnboarded === null) {
    return <LoadingIndicator />;
  }

  // This should not happen as PrivateRoute should handle it, but safety check
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to onboarding if user hasn't completed it
  if (!isOnboarded) {
    return <Navigate to="/onboarding" state={{ from: location }} replace />;
  }

  // User is authenticated and onboarded, render children
  return <>{children}</>;
};

export default OnboardedRoute;
